import React, { useEffect, useState } from "react";
import axios from "axios";
import url from "../../function/url";
import Navbar from "./Navbar";
import "../Document/Table.css";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

const JobstreamChangeRequests = () => {
  const [requests, setRequests] = useState([]);
  const [telecallers, setTelecallers] = useState([]);
  const [assignedRequests, setAssignedRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch requests
  useEffect(() => {
    const logId = Cookies.get("log_id");
    
        if (!logId) {
          setError("User not logged in or session expired. Please log in again.");
          setLoading(false);
          return;
        }
    
        console.log("Log Id :", logId);
    axios
      // .get(`${url.path}/change-requests/`)
      .get(`${url.path}/change-requests/`, {
        params: { log_id: logId },
        // withCredentials: true,
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
      })
      .then((res) => {
        console.log("Fetched Requests:", res.data);
        setRequests(res.data);

        // Extract IDs of already assigned requests
        const assignedIds = res.data
          .filter((req) => req.telecaller_assigned) // Check if telecaller_assigned is not null
          .map((req) => req.id);

        setAssignedRequests(assignedIds); // Update the state with assigned request IDs
      })
      .catch((err) => console.error(err));
  }, []);

  // Fetch telecallers
  useEffect(() => {
    axios
      .get(`${url.path}/get-telecallers/`)
      .then((res) => setTelecallers(res.data))
      .catch((err) => console.error(err));
  }, []);
const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  // Assign telecaller
  const assignTelecaller = (requestId, telecallerId) => {
    axios
      .post(`${url.path}/change-requests/${requestId}/assign/`, {
        telecaller_id: telecallerId,
      })
      .then((res) => {
        Toast.fire({
          icon: "success",
          title: "Telecaller assigned successfully!",
        });
        // alert(res.data.message);
      })
      .catch((err) => console.error(err));
  };

  const handleSearch = (event) => {
    const searchTerm = event.target.value.trim().toLowerCase();
    const rows = document.querySelectorAll("#companytable tbody tr");

    rows.forEach((row) => {
      const rowText = row.textContent.toLowerCase();
      row.style.display = rowText.includes(searchTerm) ? "" : "none";
    });
  };

  // Pagination
  const offset = currentPage * itemsPerPage;
  const currentItems = requests.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(requests.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Job/Stream Change Requests
        </h3>
      </center>
      <div className="page-wrapper">
        <div className="input-width">
          <input
            type="text"
            id="search"
            placeholder="Search in table..."
            className="search-input"
            onInput={handleSearch}
          />
        </div>
      </div>

      <div className="table-container">
        <table className="responsive-table" id="companytable">
          <thead>
            <tr>
              <th>Name</th>
              {/* <th>Email</th> */}
              <th>Employee ID</th>
              <th>Requested Change</th>
              <th>Reason for Change</th>
              <th>Assign Telecaller</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((req) => (
                <tr key={req.id}>
                  <td>{req.employee_name}</td>
                  {/* <td>{req.email}</td> */}
                  <td>{req.employee_id}</td>
                  <td>{req.requested_change}</td>
                  <td>{req.reason}</td>
                  <td>
  <select
    id={`telecaller-select-${req.id}`}
    disabled={assignedRequests.includes(req.id)}
    style={{
      padding: "5px",
      borderRadius: "5px",
      border: "1px solid #ccc",
    }}
  >
    <option value="">Select Telecaller</option>
    {telecallers.map((tc) => (
      <option key={tc.id} value={tc.id}>
        {tc.Employee_Name}
      </option>
    ))}
  </select>
</td>
<td>
  <button
    onClick={() => {
      const telecallerId = document.getElementById(
        `telecaller-select-${req.id}`
      ).value;
      if (telecallerId) {
        assignTelecaller(req.id, telecallerId);
        setAssignedRequests((prev) => [...prev, req.id]);
      } else {
        alert("Please select a telecaller before assigning.");
      }
    }}
    disabled={assignedRequests.includes(req.id)}
    style={{
      padding: "8px 12px",
      borderRadius: "5px",
      fontWeight: "bold",
      color: "white",
      backgroundColor: assignedRequests.includes(req.id) ? "green" : "blue",
      border: "none",
      cursor: assignedRequests.includes(req.id) ? "not-allowed" : "pointer",
    }}
  >
    {assignedRequests.includes(req.id) ? "Assigned" : "Assign"}
  </button>
</td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  No assigned requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {requests.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        )}
      </div>
    </>
  );
};

export default JobstreamChangeRequests;
